import { AriaDatapoint } from './AriaDatapoint';
import { Md5 } from 'ts-md5/dist/md5';
import { TraceErrorObject } from 'owa-trace';
import { isDocumentVisible } from '../utils/visibilityState';

const ErrorDatapointName = 'client_error';
const diagnosticsColumn = 'diagnostics';

export { ErrorDatapointName };

export default class ErrorDatapoint extends AriaDatapoint {
    private isExternal: boolean;
    constructor(details: TraceErrorObject) {
        let hashValue = details.stack || details.message;
        let hash = hashValue ? Md5.hashStr(hashValue) : -1;
        super(<string>hash);

        this.isExternal = details.external;
        try {
            this.addData('message', details.message);
            this.addData('background', isDocumentVisible());
            this.addIfNotNull('name', details.name);
            this.addIfNotNull('stack', details.stack || new Error(details.message).stack);
            this.addIfNotNull('file', details.filename);
            this.addIfNotNull('line', details.lineno, true);
            this.addIfNotNull('col', details.colno, true);
            this.addIfNotNull('httpstatus', details.httpStatus, true);
            this.addIfNotNull(diagnosticsColumn, details.diagnosticInfo);
            if (window?.navigator && typeof window.navigator.onLine == 'boolean') {
                this.addData('online', window.navigator.onLine);
            }
        } catch (e) {
            this.addData(diagnosticsColumn, e.message);
        }
    }
    getEventType(): string {
        return this.isExternal ? 'client_error_external' : ErrorDatapointName;
    }
    private addIfNotNull(propName: string, data: any, isInt?: boolean) {
        if (data) {
            this.addData(propName, data, isInt);
        }
    }
}
